<template>
  <div class="offline-order">
    <nav-bar titleText="卡包充值" fontColor="#333333" @goBack="goBack"></nav-bar>
    <div v-if="rechargeList.length === 0" class="emptyBox"></div>
    <div class="recommend-recharge-box" v-if="rechargeList.length">
      <div class="title">推荐充值金额</div>
      <div class="title-desc">选择推荐充值金额享充值优惠及积分赠送</div>
      <div class="recharge-list" v-for="(item, i) in rechargeList" :key="i">
        <div class="price">
          <span>¥</span>
          <span>{{parseFloat(item.recharge_amount).toFixed(2)}}</span>
        </div>
        <div class="customize-price">
          <span>送{{parseFloat(item.present_amount).toFixed(2)}}</span>
          <span>赠送部分仅在本店使用</span>
        </div>
        <div class="select-icon">
          <img v-if="selectedIndex !== i" src="../../assets/shared-hotel/unseleced.png" alt="" @click="handleSelect(item, i)">
          <img v-if="selectedIndex === i" src="../../assets/shared-hotel/selected.png" alt="" @click="handleSelect(item, i)">
        </div>
      </div>
    </div>
    <div class="customize-box">
      <span v-if="value">¥</span>
      <van-field 
        v-model="value" 
        type="digit" 
        placeholder="请输入自定义充值金额" 
        @input="handleValue"
      />
    </div>
    <div class="customize-desc">注：自定义充值金额不参与优惠活动，可赠等额积分</div>  
    <div :style="attentionStyle" class="attention" v-if="rechargeList.length && ! showAttention2">您还未选择（自定义）充值金额</div>
    <div class="attention1" v-if="!rechargeList.length && showAttention1">请输入充值金额</div>
    <div class="attention1" :style="attention1Style" v-if="showAttention2">剩余可充值额度小于输入的金额，请调整金额</div>
    <div class="button" :style="buttonStyle" @click="submit">
      <van-button 
        round
        type="info" 
        size="large" 
        color="linear-gradient(270deg, #F41A3C 0%, #FC740C 100%)" 
      >确认充值
      </van-button>
    </div> 
  </div>
</template>

<script>
import navBar from './components/navBar';
export default {
  data() {
    return {
      rechargeList: [],
      value:'',
      selectedIndex: -1,
      attentionShow: false,
      attentionShowFlag: false,
      showDialog: false,
      shopInfo:{},
      showSufficientt: false,
      showAttention1: false,
      showAttention2: false,
      client: 0,
      // offlineOrderStyle: {height: '100%'},
    }
  },
  components:{
    navBar,
  },
  computed: {
    attentionStyle(){
      return ! this.value && this.attentionShowFlag ?  {opacity: 1} : {opacity: 0}
    },
    buttonStyle(){
      if (! this.rechargeList.length) {
        return {'margin-top': '50px'}
      }
      if (this.rechargeList.length && this.showAttention2) {
        return {'margin-top': '50px'}
      }
      return {}
    },
    attention1Style(){
      return 
    },
    shop_name_computed(){
      const name = this.shopInfo.shop_name
      if (! name) {
        return ''
      }
      if (name.length > 7) {
        return name.slice(0, 7) + '...'
      }
      
      return name
    },
  },
  watch: {
    
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.deductionUA()
    this.getRechargeList()
  },
  mounted() {

  },
  methods: {
    goBack() {
        this.$router.go(-1);
    //   this.params('', '', 'goBack')
    },
    handleFocus(e){
      if (this.client === 10) {
        setTimeout(() => {
          this.offlineOrderStyle = {height: 'calc(100% - 250px)'}
        },100)
      }
    },
    handleBlur(e){
      if (this.client === 10) {
        setTimeout(() => {
          this.offlineOrderStyle = {height: '100%'}
        },100)
      }
    },

    getRechargeList(item) {
      // TODO
      // this.$route.query.id = 23
      const query = {
        id: this.$route.query.id,
      }
      this.$api.get('/offshop/member/canteen/promotion/list', query) 
      .then(data => {
        this.rechargeList = data.list.filter(item => item.status == 1)
      })
      .catch(err => {
        if (err.message) {
          this.$toast(err.message)

        }
      })
    },
    handleSelect(item, i){
      this.value = ''
      this.attentionShowFlag = false
      if (this.selectedIndex === i) {
        this.selectedIndex = -1
        // this.value = ''
        return
      }
      this.selectedIndex = i
      // this.value = item.recharge_amount
    },
    handleValue() {
      this.showAttention1 = false
      this.showAttention2 = false
      this.attentionShowFlag = false
      // if(this.value === '') {
      //   this.selectedIndex = -1
      // }
      this.selectedIndex = -1
      // if (/[^0-9.]/.test(this.value)) {
      //   this.value = this.value.slice(0, -1)
      // }
      if (/\d+\.[0-9]{3}/.test(this.value)) {
        this.value = this.value.slice(0, -1)
        this.$toast('最多输入两位小数')
      }

    },
    submit(){
      this.showAttention1 = false
      this.showAttention2 = false

      if (! this.value && this.selectedIndex == -1) {
        this.attentionShowFlag = true
        this.showAttention1 = true
        return
      }
      let presentAmount
      let v
      if (this.selectedIndex != -1) {
        presentAmount = this.rechargeList[this.selectedIndex].present_amount
        v = this.rechargeList[this.selectedIndex].recharge_amount
      }else {
        presentAmount = 0
        v = this.value
      }

      const params = {
        shop_id: this.$route.query.id,                
        recharge_amount: parseFloat(v).toFixed(2),
        present_amount: parseFloat(presentAmount).toFixed(2)
      }
      // TODO 验证 然后提交
      this.$api.post("/offshop/member/canteen/quota/confirm", params)
      .then(data => {

        if(data.confirm.is_sufficient == 1) {
          this.shopInfo = data.confirm
          // this.showDialog = true

          // 跳转充值确认页面
          this.$router.push({
            path: '/sharedHotel/confirmRechange',
            query: {
              shopInfo: this.shopInfo
            }
          })
        }else {
          this.showAttention2 = true
        }

      })
      .catch(err => {
        console.log(err)
        if (err.message) {
          this.$toast(err.message)
        }
      })

    },

    deductionUA() {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.client = 11
      } else if (/android/.test(ua)) {
        this.client = 10
      }
    },
  }
};
</script>

<style lang="less">
.offline-order {
  box-sizing: border-box;
  overflow-y: auto;
  padding-top: 88px;
  transition: height 0.1s linear;
  height: 100%;
  .emptyBox {
    height: 20px;
  }
  .recommend-recharge-box {
    padding: 0 24px;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
      margin-top: 12px;
    }
    .title-desc {
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      margin-top: 6px;
    }
    .recharge-list {
      border-radius: 3px;
      border: 1px solid #EEEEEE;
      padding: 6px 15px;
      margin-top: 12px;
      position: relative;
      .price {
        :nth-child(1) {
          font-size: 12px;
          line-height: 20px;
        }
        :nth-child(2) {
          height: 33px;
          font-size: 20px;
          font-weight: 600;
          color: #333333;
          line-height: 33px;
        }
      }
      .customize-price {
        height: 20px;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        :nth-child(2) {
          margin-left: 10px;
        }
      }
      .select-icon {
        position:absolute;                                                                                
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
        img { 
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  .customize-box {
    margin: 10px 24px 0;
    border-radius: 3px;
    border: 1px solid #EEEEEE;
    position: relative;
    span {
      position: absolute;
      top: 28px;
      left: 16px;
      z-index: 999;
      font-size: 12px;
      line-height: 20px;
      color: #F9591B;
    }
    .van-cell {
      padding: 0;
      .van-field__control {
        padding: 18px 0 17px 24px;
        height: 33px;
        box-sizing: content-box;
        font-size: 20px;
        font-weight: 600;
        color: #F9591B;
        caret-color: #999999;
        line-height: 33px;
        &::-webkit-input-placeholder {
          font-size: 16px;
          font-weight: 400;
          color: #333;
        }
      }
    }

  }
  .customize-desc {
    // height: 18px;
    font-size: 13px;
    color: #999999;
    line-height: 18px;
    padding: 0 31px 0 39px;
    margin: 10px 0;
  }
  .attention {
    height: 21px;
    font-size: 15px;
    color: #FF2D2D;
    line-height: 21px;
    padding-left: 39px;
    margin-bottom: 19px;
  }
  .attention1 {
    height: 21px;
    font-size: 15px;
    color: #FF2D2D;
    line-height: 21px;
    padding-left: 39px;
  }
  .button {
    margin: 0 12px;
    .van-button--large {
      font-size: 18px;
      font-weight: 500;
    }
  }

  .van-dialog {
    border-radius: 3px;
    width: calc(100% - 101px);
    .van-dialog__content {
      .dialog-box {
        padding: 20px 0 21px 24px;
        .row {
          height: 22px;
          font-size: 16px;
          color: #666666;
          line-height: 22px;
          margin-bottom: 12px;
          display: flex;
          span:nth-of-type(1) {
            width: 65px;
          }
          span:nth-of-type(3) {
            color: #333333;
          }
          span {
            text-align: justify;
          }
          span::after {
            content: "";
            display: inline-block;
            width: 100%;
          }
          &.last {
            margin-bottom: 0;
          }
        }
        .sufficientt {
          height: 21px;
          font-size: 15px;
          color: #FF2D2D;
          line-height: 21px;
          margin-top: 12px;
        }
      }
    }
  }
  
}
</style>
